import React, { FC } from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import { ArrowBigRightIcon } from '@utils/iconsDefs';

type Props = {
  title: string;
  onBack: () => void;
};

/**
 * The header title of a nested filter panel: the back chevron followed by the
 * name of the list the panel shows.
 *
 * The chevron is the house right chevron mirrored, since the barrel has no
 * left variant of that glyph. The button's accessible name is a plain "Back"
 * rather than a destination, because the same title heads a category's values
 * (back to the root) and one criteria's values (back to the criteria list).
 */
const FilterPanelBackTitle: FC<Props> = ({ title, onBack }) => (
  <Stack direction="row" alignItems="center" gap="4px" minWidth={0}>
    <IconButton onClick={onBack} aria-label="Back" sx={{ p: 0 }}>
      <ArrowBigRightIcon
        width={20}
        height={20}
        style={{ transform: 'scaleX(-1)' }}
      />
    </IconButton>

    <Typography variant="h5" color="grey.1000" noWrap>
      {title}
    </Typography>
  </Stack>
);

export default FilterPanelBackTitle;
